module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "confluence-card"
    }
  }, _vm._l((_vm.confluenceResults), function(result, index) {
    return _c('div', {
      key: index,
      attrs: {
        "id": "confluence-result"
      }
    }, [_c('div', {
      staticClass: "confluence-item",
      class: _vm.preloadedResult ? 'unique' : '',
      attrs: {
        "id": ("confluence-item-" + index)
      }
    }, [_c('div', {
      staticClass: "item-title"
    }, [(!_vm.preloadedResult) ? _c('router-link', {
      ref: "routerLink",
      refInFor: true,
      staticClass: "title-style",
      attrs: {
        "to": {
          path: (_vm.routeKey + "/page/" + (result.id))
        }
      }
    }, [_vm._v("\n          " + _vm._s(result.title) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.preloadedResult) ? _c('a', {
      ref: "routerLink",
      refInFor: true,
      staticClass: "title-style"
    }, [_vm._v("\n          " + _vm._s(result.title) + "\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "conf-content"
    }, [(!_vm.preloadedResult) ? _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.confluenceOpenedIndex != index),
        expression: "confluenceOpenedIndex != index"
      }],
      attrs: {
        "id": "sliced-body"
      }
    }, [_c('div', {
      staticClass: "conf-body",
      domProps: {
        "innerHTML": _vm._s(_vm.slicedContent(result.body.view.value))
      }
    }), _vm._v(" "), (result.body.view.value.length > 1000) ? _c('span', [_vm._v("...")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.confluenceOpenedIndex === index),
        expression: "confluenceOpenedIndex === index"
      }],
      staticClass: "conf-body",
      attrs: {
        "id": "expanded-body"
      },
      domProps: {
        "innerHTML": _vm._s(result.body.view.value)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "conf-lines"
    }, [(result.body.view.value.length > 1000 && !_vm.preloadedResult) ? _c('div', {
      staticClass: "conf-expander"
    }, [_c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.confluenceOpenedIndex != index),
        expression: "confluenceOpenedIndex != index"
      }],
      staticClass: "icon vertical expander",
      attrs: {
        "src": "/static/material_icons/expand_more.png"
      },
      on: {
        "click": function($event) {
          _vm.openConfluence(index);
        }
      }
    }), _vm._v(" "), _c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.confluenceOpenedIndex === index),
        expression: "confluenceOpenedIndex === index"
      }],
      staticClass: "icon vertical expander",
      attrs: {
        "src": "/static/material_icons/expand_less.png"
      },
      on: {
        "click": function($event) {
          _vm.openConfluence(index);
        }
      }
    })]) : _vm._e()])])])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-32f6d678","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/childs/ConfluenceCard.vue
// module id = 426
// module chunks = 1